import { MAILCHIMP_FLOW_PATH } from './paths'

/**
 * Whether Mailchimp AccountApplication has a completed migrate job.
 * @param {object|null|undefined} accountApplication
 * @returns {boolean}
 */
export function isCompletedMailchimpImport(accountApplication) {
    const job =
        accountApplication &&
        accountApplication.appSettings &&
        accountApplication.appSettings.migrateJob
    return !!(job && job.status === 'complete')
}

/** Path that opens the Mailchimp flow ready to pick a new import (skips Done). */
export function mailchimpImportAgainPath() {
    return MAILCHIMP_FLOW_PATH + '?again=1'
}
